import {
    GET_MEMBERSHIPPACKAGES_INFO_LOADING, MEMBERSHIPPACKAGES_DATA_SUCCESS,
    MEMBERSHIPPACKAGES_DATA_ERROR, MEMBERSHIPPACKAGES_DATA_RESET, GET_MEMBERSHIPPACKAGE_OBJECT,
    UPDATE_MEMBERSHIPPACKAGE, DELETE_MEMBERSHIPTYPEPERSON, UPDATE_MEMBERSHIPADDONS_QUANTITY, UPDATE_PACKAGE_FOR_RENEW,
    UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE, MEMBERSHIPPACKAGE_DATA_RESET
} from "../actions/actionMembershipPackages";
import { genfunction } from 'helpers';
import { ExposurePlus1Sharp } from "@material-ui/icons";

const initialState = {
    membershippackages: [],
    membershipPackage: {},
    loading: false,
    membershippackagesError: '',
    familymembersnotpartofPackage: []
};

function reducerMembershipPackages(state = initialState, action) {

    switch (action.type) {
        case GET_MEMBERSHIPPACKAGES_INFO_LOADING: {
            return {
                ...state,
                loading: true,
                membershippackagesError: ''
            };
        }

        case MEMBERSHIPPACKAGES_DATA_SUCCESS: {

            return {
                ...state,
                loading: false,
                membershippackages: action.payload,
                membershippackagesError: ''
            };
        }

        case GET_MEMBERSHIPPACKAGE_OBJECT: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.memberpackID)[0] };

            if (memPackage && memPackage.hasOwnProperty("MembershipProducts")) {

                memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                    if (e.MembershipType === "Membership") {

                        if (e.hasOwnProperty("Users") == false) {
                            e.Users = []
                        }

                    }
                    else if (e.MembershipType === "AddOn" && !e.hasOwnProperty("Quantity")) {
                        e.Quantity = 0;
                    }

                    return e;
                });

                mempackages = mempackages.filter(x => x.MembershipPackageID !== memPackage.MembershipPackageID);

                mempackages.push(memPackage);
            }


            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }
        }

        case UPDATE_MEMBERSHIPPACKAGE: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = action.payload.isEdit ? action.payload.membershipPackageDetails : { ...mempackages.filter(x => x.MembershipPackageID == action.payload.membershipPackageDetails.MembershipPackageID)[0] };

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "Membership" && action.payload.membershipPackageDetails.isEdit) {
                    e.Users = e.Users.filter(x => x.userNo != action.payload.membershipPackageDetails.userNo);
                }

                if (e.MembershipType === "Membership" && e.MembershipTypeID == action.payload.membershipPackageDetails.membershipTypeID) {

                    var user = {
                        isPrimaryMember: action.payload.membershipPackageDetails.isPrimaryMember,
                        firstName: action.payload.membershipPackageDetails.firstName,
                        lastName: action.payload.membershipPackageDetails.lastName,
                        email: action.payload.membershipPackageDetails.email,
                        dob: action.payload.membershipPackageDetails.dob,
                        phone: action.payload.membershipPackageDetails.phone,
                        address1: action.payload.membershipPackageDetails.address1,
                        address2: action.payload.membershipPackageDetails.address2,
                        city: action.payload.membershipPackageDetails.city,
                        state: action.payload.membershipPackageDetails.state,
                        zipcode: action.payload.membershipPackageDetails.zipcode,
                        country: action.payload.membershipPackageDetails.country,
                        userNo: 0,
                        UniquePackageRef: action.payload.membershipPackageDetails.UniquePackageRef,
                        isRenewal: action.payload.membershipPackageDetails.isRenewal,
                        MembershipExpiryDate: action.payload.membershipPackageDetails.MembershipExpiryDate,
                        notPartOfPackage: action.payload.membershipPackageDetails.notPartOfPackage
                    }

                    if (action.payload.membershipPackageDetails.isEdit) {
                        user.userNo = action.payload.membershipPackageDetails.userNo;
                        e.Users.push(user);
                    }
                    else {
                        if (action.payload.membershipPackageDetails.userNo < 1) {
                            user.userNo = Math.floor((Math.random() * 100000) + 100000);
                            user.UDFs = [];
                        }
                        else {
                            user.userNo = action.payload.membershipPackageDetails.userNo;
                        }

                        e.Users.push(user);
                    }
                }

                return e;
            });


            mempackages = mempackages.filter(x => x.MembershipPackageID !== memPackage.MembershipPackageID);
            mempackages.push(memPackage);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }


        }

        case DELETE_MEMBERSHIPTYPEPERSON: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.MembershipPackageID)[0] };

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "Membership" && e.MembershipTypeID == action.payload.membershipTypeID) {
                    e.Users = e.Users.filter(x => x.userNo != action.payload.userNo);
                }

                return e;
            });

            mempackages = mempackages.filter(x => x.MembershipPackageID !== memPackage.MembershipPackageID);
            mempackages.push(memPackage);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }
        }

        case UPDATE_MEMBERSHIPADDONS_QUANTITY: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.MembershipPackageID)[0] };

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "AddOn" && e.MembershipTypeID == action.payload.MembershipTypeID) {
                    if (e.hasOwnProperty("Quantity") && e.Quantity == 0) {
                        e.Quantity = 1;
                    }
                    else {
                        e.Quantity = 0;
                    }

                    e.isRenewPackage = action.payload.isRenewPackage;
                }

                return e;
            });

            mempackages = mempackages.filter(x => x.MembershipPackageID !== memPackage.MembershipPackageID);
            mempackages.push(memPackage);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }

        }
        case MEMBERSHIPPACKAGES_DATA_ERROR: {

            return {
                ...state,
                loading: false,
                membershippackagesError: action.error,
                familymembersnotpartofPackage: []
            }
        }

        case MEMBERSHIPPACKAGES_DATA_RESET: {

            return {
                ...state,
                loading: false,
                membershippackagesError: '',
                familymembersnotpartofPackage: [],
                membershippackages: [],
                membershipPackage: {}
            };
        }

        case UPDATE_PACKAGE_FOR_RENEW: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.packageID)[0] };

            var membersnotpartofPackage = { ...state.familymembersnotpartofPackage }

            if (memPackage) {

                let memberpackageDetails = genfunction.UpdateMembershipPackageForRenew(memPackage, action.payload.memberMemberships.membermerberhips[0], action.payload.customer);
                memPackage = memberpackageDetails.membershipPackage;
                membersnotpartofPackage = memberpackageDetails.userslist;

                mempackages = mempackages.filter(x => x.MembershipPackageID !== action.payload.packageID);
                mempackages.push(memPackage);
            }

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                familymembersnotpartofPackage: membersnotpartofPackage,
                membershippackagesError: ''
            }
        }

        case MEMBERSHIPPACKAGE_DATA_RESET: {

            return {
                ...state,
                membershipPackage: {}
            };

        }
        case UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE: {

            var membersnotpartofPackage = [...state.familymembersnotpartofPackage];

            var member = { ...membersnotpartofPackage.filter(x => x.userNo == action.payload.userNo)[0] };

            if (action.payload.isAdded) {
                member.notpartofPackage = false;
            }
            else {
                member.notpartofPackage = true;
            }

            membersnotpartofPackage = membersnotpartofPackage.filter(x => x.userNo != action.payload.userNo);
            membersnotpartofPackage.push(member);

            return {
                ...state,
                loading: false,
                familymembersnotpartofPackage: membersnotpartofPackage,
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerMembershipPackages;